import {ModuleWithProviders, NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ApiClientConfig} from "./services";

@NgModule({
  imports: [
    CommonModule,
  ]
})
export class ApiClientModule {
  static forRoot(config: ApiClientConfig): ModuleWithProviders<ApiClientModule> {
    return {
      ngModule: ApiClientModule,
      providers: [
        {
          provide: ApiClientConfig,
          useValue: config
        }
      ]
    };
  }
}
